import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from '@emotion/styled';
import { Button as ButtonBase } from "../Button";
import { COLORS } from "../../constants/colors";
export var Button = styled(ButtonBase)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n\n  && {\n    &:hover {\n      background-color: transparent;\n      color: ", ";\n    }\n  }\n"])), COLORS.button.text.primary.main.typography);